/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type PersonaIdentityVerificationSeverity =
  (typeof PersonaIdentityVerificationSeverity)[keyof typeof PersonaIdentityVerificationSeverity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersonaIdentityVerificationSeverity = {
  NONE: 'NONE',
  MINOR: 'MINOR',
  MAJOR: 'MAJOR',
  MISSING_NAME: 'MISSING_NAME',
} as const;
